var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.88 0H22.56L14.48 8.91144L23.92 21H16.512L10.712 13.6539L4.07199 21H0.391987L8.95199 11.4686L-0.0880127 0H7.50399L12.744 6.7107L18.88 0ZM17.592 18.9077H19.632L6.43199 2.01476H4.23999L17.592 18.9077Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/XLogo.0e9124a766173c037d6190b774199df6.svg";
export { ForwardRef as ReactComponent };